export default "__VITE_ASSET__DgJBXfwZ__"